import React from 'react';

interface QuitModalProps {
  onConfirmQuit: () => void;
  onCancel: () => void;
}

/**
 * Modal that warns users before they quit the quiz mid-game
 * Walking out means losing all progress and prizes
 */
const QuitModal: React.FC<QuitModalProps> = ({ onConfirmQuit, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="bg-gradient-to-br from-kbc-dark via-kbc-dark-accent to-kbc-dark border-2 border-kbc-error rounded-2xl p-8 max-w-md w-full shadow-2xl animate-scale-in">
        {/* Warning Icon */}
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-kbc-error mb-2">
            Walk Out of Quiz?
          </h2>
        </div>

        {/* Warning Message */}
        <div className="bg-white/5 rounded-lg p-6 mb-6 border border-white/10">
          <p className="text-white text-center leading-relaxed mb-4">
            Are you sure you want to quit? If you walk out now:
          </p>
          <ul className="text-white/90 space-y-2 text-sm">
            <li className="flex items-start">
              <span className="text-kbc-error mr-2">✗</span>
              <span>You will <strong>lose all progress</strong></span>
            </li>
            <li className="flex items-start">
              <span className="text-kbc-error mr-2">✗</span>
              <span>You will <strong>not win any prize</strong></span>
            </li>
            <li className="flex items-start">
              <span className="text-kbc-error mr-2">✗</span>
              <span>You <strong>cannot return</strong> to this quiz</span>
            </li>
            <li className="flex items-start">
              <span className="text-kbc-error mr-2">✗</span>
              <span>This counts as <strong>walking out</strong> of the game</span>
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={onCancel}
            className="bg-gradient-to-r from-kbc-success to-green-600 hover:from-green-600 hover:to-kbc-success text-white font-bold py-3 px-6 rounded-lg transition transform hover:scale-105 active:scale-95"
          >
            Continue Quiz
          </button>
          <button
            onClick={onConfirmQuit}
            className="bg-gradient-to-r from-kbc-error to-red-600 hover:from-red-600 hover:to-kbc-error text-white font-bold py-3 px-6 rounded-lg transition transform hover:scale-105 active:scale-95"
          >
            Walk Out
          </button>
        </div>

        <p className="text-white/50 text-xs text-center mt-4">
          💡 Tip: You can cash out at tier completion to secure your prize!
        </p>
      </div>
    </div>
  );
};

export default QuitModal;
